'use strict';

const { GridStack } = require('gridstack');

// This bundle and the Clinical chart's separate GridStack bundle both number their
// per-instance `gs-id-N` stylesheet classes from zero. With `styleInHead` those
// stylesheets share `<head>`, so a shared `gs-id-0` lets our rules restyle Clinical's
// grid. Offset our sequence clear of anything Clinical will reach.
GridStack.Engine._idSeq = 1000;

class GridStackLayout extends HTMLElement {
  connectedCallback() {
    if (this.grid) return;
    if (!this.classList.contains('grid-stack')) {
      this.classList.add('grid-stack');
    }
    requestAnimationFrame(() => {
      if (!this.isConnected || this.grid) return;
      const options = {
        float: false,
        animate: false,
        styleInHead: true,
        resizable: { handles: 'se' },
        alwaysShowResizeHandle: true,
        column: parseInt(this.getAttribute('columns'), 10) || 12,
        cellHeight: parseInt(this.getAttribute('cell-height'), 10) || 'auto',
        margin: parseInt(this.getAttribute('margin'), 10) || 0,
        handle: this.getAttribute('handle') || undefined,
        columnOpts: {
          breakpointForWindow: true,
          layout: 'list',
          // Keep in sync with the lg breakpoint (1200px) in gridstack.pcss.
          breakpoints: [{ w: 1199, c: 1 }],
        },
      };
      this.style.setProperty('--gridstack-outer-margin', `${options.margin}px`);
      this.grid = GridStack.init(options, this);
      this._observeChildren();
    });
  }

  _observeChildren() {
    this._observer = new MutationObserver((mutations) => {
      if (!this.grid) return;
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && node.classList.contains('grid-stack-item') && !node.gridstackNode) {
            this.grid.makeWidget(node);
          }
        }
        for (const node of m.removedNodes) {
          if (
            node.nodeType === 1 &&
            node.classList.contains('grid-stack-item') &&
            node.gridstackNode &&
            !node.isConnected
          ) {
            this.grid.removeWidget(node, false);
          }
        }
      }
    });
    this._observer.observe(this, { childList: true });
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this.grid) {
      this.grid.destroy(false); // false = keep DOM (Elm owns it)
      this.grid = null;
    }
  }
}

if (!customElements.get('gridstack-layout')) {
  customElements.define('gridstack-layout', GridStackLayout);
}

module.exports = GridStackLayout;
